import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { createGlobalStyle } from 'styled-components';
import dataTestIds from '~/test/test-ids';
import { showChatEntrypoint } from '../../../../../core/util/account';
import { useAccount } from '../../../../../hooks/account/useAccount';
import useRuntimeVariable from '../../../../../hooks/runtime/useRuntimeVariable';
import useSelectActiveUserProfile from '../../../../../hooks/useSelectActiveUserProfile';
import BottomNavAction from './components/BottomNavAction';
import StuckToTheBottom from './components/StuckToTheBottom';
import AppointmentsIcon from './icons/AppointmentsIcon';
import ChatIcon from './icons/ChatIcon';
import GetCareIcon from './icons/GetCareIcon';
import InsuranceIcon from './icons/InsuranceIcon';
import ProfileIcon from './icons/ProfileIcon';
import { useLDFlags } from '~/core/launch-darkly/hooks/useLDFlags';

const GlobalStyles = createGlobalStyle`
  #app {
    width: 100%;
    padding-bottom: 56px;
  }

  body, html {
    height: 100%;
    width: 100%;
  }
`;

type Props = {
  viewName?: string;
};

const BottomNav = (props: Props) => {
  const { viewName } = props;
  const { t } = useTranslation(['common']);
  const { plus673IsIntercomEnabled } = useLDFlags();
  const account = useAccount();
  const activeUserProfile = useSelectActiveUserProfile();
  const showChatIcon = showChatEntrypoint(
    plus673IsIntercomEnabled,
    account,
    activeUserProfile,
    true
  );

  const [showConciergeChat] = useRuntimeVariable('showConciergeChat', false);
  const [unreadChats] = useRuntimeVariable('unreadChats', false);

  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(
    <>
      <StuckToTheBottom viewName={viewName}>
        <BottomNavAction
          data-testid={dataTestIds.srp.mobileNav.getCareBtn}
          icon={<GetCareIcon />}
          label={t('common:nav.tabs.getCare')}
        />
        <BottomNavAction
          data-testid={dataTestIds.srp.mobileNav.appointmentsBtn}
          icon={<AppointmentsIcon />}
          label={t('common:nav.tabs.visits')}
        />
        {showChatIcon ? (
          <BottomNavAction
            data-testid={dataTestIds.srp.mobileNav.chatBtn}
            icon={<ChatIcon isChatShowing={showConciergeChat} unreadChats={unreadChats} />}
            label={t('common:nav.tabs.chat')}
          />
        ) : (
          <></>
        )}
        <BottomNavAction
          data-testid={dataTestIds.srp.mobileNav.insuranceBtn}
          icon={<InsuranceIcon />}
          label={t('common:nav.tabs.insurance')}
        />
        <BottomNavAction
          data-testid={dataTestIds.srp.mobileNav.profileBtn}
          icon={<ProfileIcon />}
          label={t('common:nav.tabs.profile')}
        />
      </StuckToTheBottom>

      <GlobalStyles />
    </>,
    document.body
  );
};

export default BottomNav;
